import "@progress/kendo-ui/js/kendo.angular";
import "@progress/kendo-ui/js/kendo.core";
import "@progress/kendo-ui/js/kendo.data";
import "@progress/kendo-ui/js/kendo.grid";

import * as angular from "angular";

import { HIERARCHY_SERVICE, HierarchyService } from "../hierarchy-service/hierarchy.service";
import { HIERARCHY_COMPONENT, hierarchyGridComponent } from "./hierarchyGrid.component";

export default angular
    .module("board.web.admin.hierarchyGrid", ["kendo.directives"])
    .component(HIERARCHY_COMPONENT, hierarchyGridComponent)
    .service(HIERARCHY_SERVICE, HierarchyService)
    .name;



// WEBPACK FOOTER //
// ./app/hierarchy-grid/hierarchy.module.ts